/* eslint-disable react/prop-types */
import React from "react";
import { Typography, Button, TextField, makeStyles } from "@material-ui/core";
import useFormFields from "lib/forms";
import { Auth, Amplify } from "aws-amplify";
import { useHistory } from "react-router-dom";
import awsConfig, { awsInternalConfig } from "aws-exports";
import _ from "lodash";

const useStyles = makeStyles(() => ({
  formButton: {
    marginTop: "20px",
  },
  recoveryMesage: {
    fontSize: "12px",
  },
  sendCodeTextField: {
    marginTop: "5px",
  },
}));

const NewPasswordForm = ({ setAlertMessage, cognitoUser }) => {
  const history = useHistory();
  const classes = useStyles();
  const [fields, handleFieldChange] = useFormFields({
    password: "",
    confirmPassword: "",
  });

  function containsSpecialChars(str) {
    const specialChars = /[`!#$%^&*()_+=[\]{};':"\\|,<>/?~]/;
    return specialChars.test(str);
  }

  function containsUpper(str) {
    return /[A-Z]/.test(str);
  }

  const handleSetNewPasswordSubmit = (event) => {
    event.preventDefault();
    Amplify.Logger.LOG_LEVEL = "INFO"; // We write INFO level logs throughout app
    if (cognitoUser.username.split("@")[1] === "wiseathena.com") {
      Amplify.configure(awsInternalConfig);
    } else {
      Amplify.configure(awsConfig);
    }

    if (fields.confirmPassword !== fields.password) {
      setAlertMessage("Passwords provided do not match.");
      return false;
    }

    if (!containsSpecialChars(fields.confirmPassword)) {
      setAlertMessage("Password must contain at least one special character.");
      return false;
    }

    if (!containsUpper(fields.confirmPassword)) {
      setAlertMessage("Password must contain at least one uppercase letter.");
      return false;
    }

    if (
      !_.some([0, 1, 2, 3, 4, 5, 6, 7, 8, 9], (el) =>
        _.includes(fields.password, el)
      )
    ) {
      setAlertMessage("Password must contain at least one number.");
      return false;
    }

    if (fields.password.length < 16) {
      setAlertMessage("Password must contain at least 16 characters.");
      return false;
    }

    Auth.completeNewPassword(
      cognitoUser, // the Cognito User Object
      fields.password // the new password
    )
      .then(() => {
        history.push({ pathname: "/" });
      })
      .catch((err) => {
        setAlertMessage(err.message);
      });

    return false;
  };

  return (
    <>
      <Typography variant="body1" classes={{ body1: classes.recoveryMesage }}>
        Change your temporary password before proceeding
      </Typography>
      <form
        onSubmit={handleSetNewPasswordSubmit}
        data-testid="new-password-form"
      >
        <TextField
          variant="outlined"
          size="small"
          margin="normal"
          classes={{ root: classes.sendCodeTextField }}
          required
          fullWidth
          name="password"
          label="New password"
          type="password"
          id="password"
          autoComplete="off"
          onChange={handleFieldChange}
        />
        <TextField
          variant="outlined"
          size="small"
          margin="normal"
          required
          fullWidth
          name="confirmPassword"
          label="Confirm password"
          type="password"
          id="confirmPassword"
          autoComplete="off"
          onChange={handleFieldChange}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.formButton}
        >
          Change Password and proceed
        </Button>
      </form>
    </>
  );
};

export default NewPasswordForm;
